import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames/bind';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Link, { linkBase } from '@src/mobile/components/Link';
import { useFixedNav } from '@src/mobile/hooks';
import { isGrounds, groundsClose, openAppShare } from '@src/mobile/utils/app';
import styles from './index.css';
import { Store } from '../store';

const cx = classNames.bind(styles);

const Banner = () => {
    // store
    const store = Store.useContainer();
    const { states, changeStates } = store;
    const { statusBarHeight, showFixedNav, shareTitle, shareDesc, shareThumbnail } = states;

    // nav的ref
    const navRef = useRef();
    // banner的ref
    const wrapRef = useRef();
    // 展示nav背景的高度
    const [fixedTop, setFixedTop] = useState(0);

    useEffect(
        () => {
            if (navRef.current && wrapRef.current) {
                setFixedTop(wrapRef.current.offsetHeight - navRef.current.offsetHeight);

                changeStates({ navHeight: navRef.current.offsetHeight });
            }
        },
        [statusBarHeight],
    );

    useFixedNav(fixedTop, showFixedNav => {
        changeStates({ showFixedNav });
    });

    const handleBackClick = () => {
        groundsClose();
    };

    const handleShareClick = () => {
        openAppShare({
            title: shareTitle,
            desc: shareDesc,
            thumbnail: shareThumbnail,
        });
    };

    return (
        <>
            {isGrounds ? (
                <div className={styles.nav} style={{ paddingTop: statusBarHeight }} ref={navRef}>
                    <div className={cx('navBg', { showNavBg: showFixedNav })} />
                    <div className={styles.navContent}>
                        <div className={styles.navBack} onClick={handleBackClick} />
                        <div className={cx('navTitle', { showNavTitle: showFixedNav })}>奖牌榜</div>
                        <div className={styles.navShare} onClick={handleShareClick} />
                    </div>
                </div>
            ) : null}

            <div className={cx('wrap', { wrapShare: !isGrounds })} ref={wrapRef} />
        </>
    );
};

export default errorBoundary(Banner);
